export default {
	SET_SETTINGS(state, payload) {
		// Sorting
		state.listing.sorting = payload.listing.columns

		// itemsPerPage
		state.listing.itemsPerPage = payload.listing.itemsPerPage
	},

	SET_LIST(state, payload) {
		state.listing.list = payload
	},

	SET_DETAIL(state, payload) {
		state.detail.data = payload
	},

	SET_SORTING(state, payload) {
		state.listing.sorting = payload
	},

	SET_PAGE(state, payload) {
		state.listing.page = payload
	},

	SET_TOTAL_COUNT(state, payload) {
		state.listing.numberOfItems = payload
	},

	SET_SEARCH_TERM(state, payload) {
		state.listing.searchTerm = payload
	},

	SET_FILTER_IS_FILTERING(state, payload) {
		state.listing.filter.isFiltering = payload
	},

	SET_FILTER_PAYLOAD(state, payload) {
		state.listing.filter.payload = payload
	},

	SET_FILTER_WHERE(state, payload) {
		state.listing.filter.where = payload
	},

	SET_BENEFIT_INFOS(state, payload) {
		state.detail.benefitInfos = payload
	},

	SET_CLIENT_TYPE(state, payload) {
		state.creating.clientType = payload
	},

	ADD_LOADING(state, key = "listing") {
		state[key].loading.push(1)
	},

	REMOVE_LOADING(state, key = "listing") {
		state[key].loading.splice(0, 1)
	}
}
